import { useMutation, useQueryClient } from 'react-query'

import { handleApiErrors } from '../../../utils/apiErrors'
import { getEnvs } from '../../../utils/env'

export const useDownloadPlanningOptimizationProcess = () => {
  const queryClient = useQueryClient()
  const { apiUrl } = getEnvs()
  return useMutation(
    [`optimization-processes`, `download-excel`],
    async (optimizationProcessId: number) => {
      const response = await fetch(
        `${apiUrl}/optimization-processes/download-excel/?optimization_process_id=${optimizationProcessId}`,
        {
          method: 'GET',
          headers: {
            'Content-Type': 'application/xlsx',
          },
          credentials: 'include',
        }
      )

      if (!response.ok) {
        throw new Error(
          `Failed to download planning XLS file of process ${optimizationProcessId}`
        )
      }

      const blob = await response.blob()
      const url = window.URL.createObjectURL(blob)
      const a = document.createElement('a')
      a.href = url
      a.download = `optimization-processes_${optimizationProcessId}.xlsx`
      document.body.appendChild(a)
      a.click()
      document.body.removeChild(a)
      window.URL.revokeObjectURL(url)
    },
    {
      onError: handleApiErrors,
      onSuccess: () => {
        queryClient.invalidateQueries(['optimization-processes'])
      },
    }
  )
}
